import styled from 'styled-components';

interface IDateSelectorContainerProps {
  compactView?: boolean;
}

export const DateSelectorContainer = styled('div')<IDateSelectorContainerProps>`
  display: flex;
  flex-direction: ${({ compactView }) => (compactView ? 'column' : 'row')};
  @media screen and (max-width: 1000px) {
    flex-direction: column !important;
  }
`;
